<template>
  <div class="secur-ity m-consumption">
    <div class="u-toptilte">
      <p><i style="color:#FFCC00">▎</i>包时卡转让</p>
    </div>
    <p v-show="yshiming" class="yshiming">
      您还未进行实名认证，请先进行
      <a style="color:#356ded; " @click="chongzhi"> <u>实名认证</u> </a
      >后再进行转让计时卡操作。
    </p>

    <div class="signIn" v-show="wshiming">
      <div class="form">
        <el-form
          label-width="120px"
          :label-position="mobile_flag ? 'top' : 'right'"
        >
          <el-row>
            <el-col>
              <el-form-item label="确认转出号码：">
                <el-input
                  placeholder="输入当前用户手机号码"
                  @blur="phoneFrom"
                  v-model="shuru.phoneFrom"
                ></el-input>
                <div class="el-form-item__error">{{ cuowuspan.phoneFrom }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" align="bottom">
            <el-col :span="14">
              <el-form-item label="验证码：">
                <el-input
                  placeholder="请输入六位验证码"
                  @blur="Verificationa"
                  v-model="shuru.Verification"
                ></el-input>
                <div class="el-form-item__error">
                  {{ cuowuspan.Verification }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item></el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item>
                <!-- :disabled="disabled  || shuru.phone.length!=11" -->
                <el-button
                  type="warning"
                  round
                  :disabled="disabled"
                  @click="send"
                  class="yzm"
                  >{{ sends }}</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item label="对方手机号码：">
                <el-input
                  placeholder="输入对方手机号码"
                  @blur="phoneTo"
                  v-model="shuru.phoneTo"
                ></el-input>
                <div class="el-form-item__error">{{ cuowuspan.phoneTo }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item>
                <div class="u-btton">
                  <el-button type="warning" round @click="forget"
                    >&emsp;&emsp;&emsp;确认修改&emsp;&emsp;&emsp;</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- <div class="Registerbtn">
          <a

            :class="[checked==true?'Registerbtnl':'Registerbtnm']"
            @click="forget"
          >确认修改</a>
      </div>-->
    </div>
  </div>
</template>
<script>
import adaption from '@/mixi/adaption'
export default {
  mixins: [adaption],
  metaInfo: {
    title:'云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content:
          '修改海星云账号,修改密码,云游戏:海星云平台,海星云,云游戏,5G云游戏,海星云主机,海星云电脑,海星云2080ti,云平台,星瀛科技,星瀛云,4K高清游戏,手机玩电脑游戏,移动端steam,移动端3A,下载牛牛游戏,牛牛游戏下载,牛牛游戏大厅,网络游戏,好玩的游戏,权利的游戏,网易游戏'
      },
      {
        name: 'description',
        content:
          '作为硬核玩家与极客团队，创造了星瀛科技（北京）有限公司，融入5G时代新应用产业的发展，自主研发高性能“海星云”云游戏平台，提供软硬件综合解决方案，让伙伴们不再是云玩家，在任意时间、任意地点、任意设备，共享高画质流畅体验。未来，我们的征途是星辰大海，勇气与胸怀是我们踏上远方的陪伴，迈向星河彼岸，须弥胜境。-修改海星云账号,修改密码'
      }
    ]
  },
  data () {
    return {
      // 滑块参数
      nc_token: '',
      csessionid: '',
      sig: '',
      // 发送验证按按钮
      sendstime: 60,
      disabled: false,
      sends: '获取验证码',
      checked: false,
      // phone: "",
      // 输入的数据
      shuru: {
        phoneFrom: '',
        phoneTo: '',
        phone: '',
        Verification: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phoneFrom: '',
        phoneTo: '',
        phone: '',
        Verification: ''
      },
      // 标识符
      isPhoneFrom: false,
      isPhoneTo: false,
      user_phone: '', // 当前登录用户的手机号码
      Verification: false,
      yshiming: true,
      wshiming: false
    }
  },
  methods: {
    chongzhi () {
      this.$router.push({
        path: './Real_name',
        query: {
          information: 1
        }
      })
    },
    send () {
      if (!this.shuru.phoneFrom || this.isPhoneFrom) {
        return
      }
      this.nc_token = this.$cookieStore.getCookie('nc_token')
      this.csessionid = this.$cookieStore.getCookie('csessionid')
      this.sig = this.$cookieStore.getCookie('sig')

      this.http
        // .send(this.user_phone, this.nc_token, this.csessionid, this.sig)
        .send(this.shuru.phoneFrom, this.nc_token, this.csessionid, this.sig)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'ok') {
              this.$message({
                message: '验证码已发送到您的手机，请注意查看',
                type: 'success'
              })
              var that = this
              var resend = setInterval(function () {
                that.sendstime--
                if (that.sendstime > 0) {
                  that.sends = that.sendstime + 's后重新获取'
                  that.disabled = true
                } else {
                  clearInterval(resend)
                  that.sends = '获取验证码'
                  that.sendstime = 60
                  that.disabled = false
                }
              }, 1000)
            }
          } else if (res.data.code == 400) {
            if (res.data.message == 'failed,unable to get data') {
              this.$message.error('不能获取到数据')
            } else if (res.data.message == 'failed,user phone invalid') {
              this.$message.error('手机号无效')
            } else if (res.data.message == 'failed,afs authenticate invalid') {
              this.$message.error('滑块验证失败')
            }
          } else if (res.data.code == 500) {
            if (res.data.message == 'failed,please retry!') {
              this.$message.error('验证码发送过于频繁，请稍后再试。，请重试！')
            }
          }
        })
    },

    forget () {
      if (this.shuru.phoneTo == '' || this.shuru.Verification == '') {
        return false
      } else if (this.isPhoneTo == true || this.Verification == true) {
        return false
      } else {
        this.http
          .gift_card(
            this.shuru.phoneTo,
            this.shuru.Verification,
            this.$route.query.card
          )
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: 'success'
              })
              this.$router.push('./card')
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch(err => {
            this.$message.error('赠送失败')
          })
      }
    },
    phoneFrom () {
      if (this.shuru.phoneFrom == '') {
        this.isPhoneFrom = true
        this.cuowuspan.phoneFrom = '请填写当前用户手机号'
        return false
      } else if (this.shuru.phoneFrom) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phoneFrom)) {
          this.isPhoneFrom = false
          this.cuowuspan.phoneFrom = ''
        } else {
          this.isPhoneFrom = true
          this.cuowuspan.phoneFrom = '手机号格式有误'
          return false
        }
      }
    },

    phoneTo () {
      if (this.shuru.phoneTo == '') {
        this.isPhoneTo = true
        this.cuowuspan.phoneTo = '请填写对方手机号'
        return false
      } else if (this.shuru.phoneTo) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phoneTo)) {
          this.isPhoneTo = false
          this.cuowuspan.phoneTo = ''
        } else {
          this.isPhoneTo = true
          this.cuowuspan.phoneTo = '手机号格式有误'
          return false
        }
      }
    },
    Verificationa () {
      if (this.shuru.Verification == '') {
        this.cuowuspan.Verification = '请输入验证码'
        this.Verification = true
        return false
      } else if (this.shuru.Verification) {
        var reg = /^\d{6}$/
        if (reg.test(this.shuru.Verification)) {
          this.Verification = false
          this.cuowuspan.Verification = ''
        } else {
          this.Verification = true
          this.cuowuspan.Verification = '验证码格式有误'
          return false
        }
      }
    }

    // 滑块
    // init() {
    //   var that = this;
    //   var nc_token = [
    //     "FFFF0N0000000000805E",
    //     new Date().getTime(),
    //     Math.random()
    //   ].join(":");
    //   var NC_Opt = {
    //     renderTo: "#your-dom-id",
    //     appkey: "FFFF0N0000000000805E",
    //     scene: that.sceneaa,
    //     token: nc_token,
    //     customWidth: 300,
    //     trans: { key1: "code0" },
    //     elementID: ["usernameID"],
    //     is_Opt: 0,
    //     language: "cn",
    //     isEnabled: true,
    //     timeout: 3000,
    //     times: 5,
    //     apimap: {},
    //     callback: function(data) {
    //       that.$cookieStore.setCookie("nc_token", nc_token, 600);
    //       that.$cookieStore.setCookie("csessionid", data.csessionid, 600);
    //       that.$cookieStore.setCookie("sig", data.sig, 600);
    //     }
    //   };
    //   var nc = new noCaptcha(NC_Opt);
    //   nc.upLang("cn", {
    //     _startTEXT: "请拖动滑块进行验证",
    //     _yesTEXT: '验证通过,<a href="javascript:__nc.reset()">点击刷新</a>',
    //     _error300:
    //       '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
    //     _errorNetwork:
    //       '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
    //   });
    // }
  },
  mounted () {
    this.http.gerenzx().then(res => {
      this.user_phone = res.data.data.phone
      if (res.data.data.active == true) {
        this.wshiming = true
        this.yshiming = false
      }
    })
    // this.init();
  },
  beforeDestroy () {
    this.$cookieStore.delCookie('nc_token')
    this.$cookieStore.delCookie('csessionid')
    this.$cookieStore.delCookie('sig')
  }
}
</script>
<style>
/* .yshiming {
  padding: 347px 0;
  text-align: center;
  font-size: 1.25rem;
  font-weight: bold;
}

#forget {
  width: 798px;
  height: 752px;
  border: 15px solid #fff;
  border-radius: 13px;
  background: rgba(242, 242, 242, 1);
  padding: 20px;
}

.signIn {
  position: relative;
  margin: 0 auto;
}
.signIn .from {
  padding-left: 30px;
}
.signIn > p {
  height: 80px;
  font-size: 24px;
  font-weight: bold;
  color: rgba(41, 92, 164, 1);
  line-height: 80px;
  margin-bottom: 20px;
}
.signIn > p img {
  vertical-align: middle;
  margin-right: 15px;
}
.inputm {
  border: 2px solid #dfdfdf;
}
.inputh {
  border: 2px solid #e60012;
  background: #ffe4e4;
}
.signIn .input {
  height: 55px;
  margin-bottom: 20px;
}
.signIn .input div {
  position: relative;
}

.signIn .input p {
  width: 268px;
  line-height: 55px;
  height: 55px;
  font-size: 20px;
  color: rgba(41, 92, 164, 1);
}
.signIn .input input {
  display: block;
  padding: 6px 14px;
  width: 300px;
  height: 24px;
  border-radius: 5px;
}
.signIn .input span {
  position: absolute;
  top: 40px;
  left: 268px;
  font-size: 12px;
  color: #e60012;
}
.Registerbtnm {
  background: #b1b1b1;
}
.Registerbtnl {
  background: #295ca4;
}
.signIn .Registerbtn a {
  width: 110px;
  height: 18px;
  display: block;
  padding: 9px 20px;
  border: 1px solid #b1b1b1;
  border-radius: 19px;
  color: #fff;
  text-align: center;
  margin: 30px auto;
} */
</style>



// WEBPACK FOOTER //
// src/components/gift_card.vue